module.exports = [
  {
    env: 'preview',
    domain: ['az-pilot.tsepcn.com'],
    mobileDomain: 'az-h5-pilot.tsepcn.com',
    aegisId: 'p0pP1fkL3qmPELZq80',
    reportDomain: 'baike.sparta.html5.qq.com',
  },
  {
    env: 'preview',
    domain: ['ncep-pre.astrazeneca.cn'],
    mobileDomain: 'ncep-h5-pre.astrazeneca.cn',
    aegisId: 'p0pP1fkL3qmPELZq80',
    reportDomain: 'baike.sparta.html5.qq.com',
  },
];
